const domains = ['qq.com', '10minutemail.com', '2prong.com', '4warding.com', '6url.com', 'afrobacon.com', 'bugmenot.com', 'bumpymail.com', 'centermail.com', 'centermail.net', 'choicemail1.com', 'deadspam.com', 'despam.it', 'despammed.com', 'discardm ail.com', 'discardmail.de', 'disposeamail.com', 'dodgeit.com', 'dontreg.com', 'dontsendmespam.de', 'dumpandjunk.com', 'dumpmail.de', 'e4ward.com', 'emaildienst.de', 'emailias.com', 'emailto.de', 'emailxfer.com', 'emz.net', 'enterto.com', 'front14.org', 'getonemail.com', 'ghosttexter.de', 'gishpuppy.com', 'greensloth.com', 'guerrillamail.com', 'guerrillamail.net', 'h8s.org', 'haltospam.com', 'hatespam.org', 'hidemail.de', 'iheartspam.org', 'ipoo.org', 'jetable.com', 'jetable.net', 'jetable.org', 'kasmail.com', 'killmail.com', 'killmail.net', 'klassmaster.net', 'link2mail.net', 'lortemail.dk', 'mail2rss.org', 'mail333.com', 'mailblocks.com', 'maileater.com', 'mailexpire.com', 'mailfreeonline.com', 'mailmoat.com', 'mailnull.com', 'mailshell.com', 'mailsiphon.com', 'mailzilla.com', 'meinspamschutz.de', 'messagebeamer.de', 'mintemail.com', 'myspamless.com', 'mytrashmail.com', 'neomailbox.com', 'nervmich.net', 'nervtmich.net', 'netmails.com', 'netmails.net', 'netzidiot.de', 'nobulk.com', 'noclickemail.com', 'nospamfor.us', 'nurfuerspam.de', 'oneoffemail.com', 'oopi.org', 'outlawspam.com', 'pancakemail.com', 'poofy.org', 'pookmail.com', 'privacy.net', 'punkass.com', 'rejectmail.com', 'safersignup.de', 'shortmail.net', 'sibmail.com', 'slaskpost.se', 'sneakemail.com', 'sofort-mail.de', 'spam.la', 'spamavert.com', 'spambob.com', 'spambob.net', 'spambob.org', 'spambox.us', 'spamcon.org', 'spamday.com', 'spamex.com', 'spamfree24.com', 'spamfree24.net', 'spamfree24.org', 'spamgourmet.com', 'spamhole.com', 'spamify.com', 'spaminator.de', 'spamslicer.com', 'spaml.com', 'spammotel.com', 'spamoff.de', 'spamtrail.com', 'tempemail.net', 'tempinbox.com', 'temporarily.de', 'temporaryforwarding.com', 'temporaryinbox.com', 'trashmail.com', 'trashmail.net', 'trashmail.org', 'trashmail.de', 'trash-mail.de', 'twinmail.de', 'venompen.com', 'wegwerfadresse.de', 'wh4f.org', 'willselfdestruct.com', 'wuzup.net', 'wwwnew.eu', 'xemaps.com', 'xents.com', 'xmaily.com', 'yep.it', 'yopmail.com', 'zoemail.org', 'fakeinformation.com', 'fastacura.com', 'fastchevy.com', 'fastchrysler.com', 'fastkawasaki.com', 'fastmazda.com', 'fastmitsubishi.com', 'fastnissan.com', 'fastsubaru.com', 'fastsuzuki.com', 'fasttoyota.com', 'fastyamaha.com', 'fux0ringduh.com', 'klassmaster.com', 'mailin8r.com', 'mailinator.com', 'mailinater.com', 'mailinator2.com', 'sogetthis.com', '675hosting.com', '675hosting.net', '675hosting.org', '75hosting.com', '75hosting.net', '75hosting.org', 'ajaxapp.net', 'amiri.net', 'amiriindustries.com', 'emailmiser.com', 'etranquil.com', 'etranquil.net', 'etranquil.org', 'gowikibooks.com', 'gowikicampus.com', 'gowikicars.com', 'gowikifilms.com', 'gowikigames.com', 'gowikimusic.com', 'gowikinetwork.com', 'gowikitravel.com', 'gowikitv.com', 'iwi.net', 'myspaceinc.com', 'myspaceinc.net', 'myspaceinc.org', 'myspacepimpedup.com', 'ourklips.com', 'pimpedupmyspace.com', 'rklips.com', 'turual.com', 'upliftnow.com', 'uplipht.com', 'viditag.com', 'viewcastmedia.com', 'viewcastmedia.net', 'viewcastmedia.org', 'wetrainbayarea.com', 'wetrainbayarea.org', 'xagloo.com', 'anonymail.dk', 'blogmyway.org', 'buyusedlibrarybooks.org', 'dotmsg.com', 'fakemailz.com', 'footard.com', 'forgetmail.com', 'lovemeleaveme.com', 'mailquack.com', 'mailslapping.com', 'oneoffmail.com', 'recyclemail.dk', 'shiftmail.com', 'spambog.com', 'spambog.de', 'spammotel.com', 'trashdevil.com', 'trashdevil.de', 'whopy.com', 'wilemail.com', '1chuan.com', '1zhuan.com', '4warding.com', '4warding.net', '4warding.org', 'imstations.com', 'walala.org', 'gorillaswithdirtyarmpits.com', 'bugmenot.com', 'gmail.com', 'googlemail.com', 'yahoo.com', 'yahoo.co.uk', 'live.com', 'yahoo.in', 'hotmail.com', 'hotmail.co.uk', 'rocketmail.com', 'ymail.com', 'ymail.co.uk', 'aol.com']

$(document).ready(function () {

    $('#email-sales_cta__country').on('change', function (event) {
        if (this.value === 'US') {
            $('#email-sales_cta__form-state').show()
            $('#email-sales_cta__form-province').hide()
        } else if (this.value === 'CA') {
            $('#email-sales_cta__form-province').show()
            $('#email-sales_cta__form-state').hide()
        } else {
            $('#email-sales_cta__form-state').hide()
            $('#email-sales_cta__form-province').hide()
        }
    })

    $('#email-sales_cta__form input').on('change', function () {
        if (isValidForm()) {
            $('#email-sales_cta__form_submit').prop('disabled', false)
        } else {
            $('#email-sales_cta__form_submit').prop('disabled', true)
        }
    })

    $('#email-sales_cta__form').submit(function (event) {
        event.preventDefault();
        if (isValidForm()) {
            this.submit()
        }
    })

    $('#email-sales_cta__email').on('change', function () {
        $('#email-sales_cta__email_error').hide()
        if (!isNonFreeEmail()) {
            $('#email-sales_cta__email_error').show().text('Free email accounts are not valid.')
        }
        if (!isValidEmail()) {
            $('#email-sales_cta__email_error').show().text('Please enter a valid email address.')
        }
    })
    $('#email-sales_cta__first-name').on('change', function () {
        $('#email-sales_cta__first-name_error').hide()
        if (!isValidFirstName()) {
            $('#email-sales_cta__first-name_error').show().text('Please enter your first name.')
        }
    })
    $('#email-sales_cta__last-name').on('change', function () {
        $('#email-sales_cta__last-name_error').hide()
        if (!isValidLastName()) {
            $('#email-sales_cta__last-name_error').show().text('Please enter your last name.')
        }
    })
    $('#email-sales_cta__company-name').on('change', function () {
        $('#email-sales_cta__company-name_error').hide()
        if (!isValidCompanyName()) {
            $('#email-sales_cta__company-name_error').show().text('Please enter your company name.')
        }
    })
    $('#email-sales_cta__phone').on('change', function () {
        $('#email-sales_cta__phone_error').hide()
        if (!isValidPhone()) {
            $('#email-sales_cta__phone_error').show().text('Please enter a contact number.')
        }
    })


    function isValidFirstName() {
        return $('#email-sales_cta__first-name').val().length >= 2
    }

    function isValidLastName() {
        return $('#email-sales_cta__last-name').val().length >= 2
    }

    function isValidCompanyName() {
        return $('#email-sales_cta__company-name').val().length >= 2
    }

    function isValidPhone() {
        return $('#email-sales_cta__phone').val().length > 7
    }

    function isNonFreeEmail() {
        return !domains.some((dom) => {
            return $('#email-sales_cta__email').val().includes(dom)
        })
    }

    function isValidEmail() {
        return /\S+@\S+\.\S+/.test($('#email-sales_cta__email').val())
    }

    function isTermsAgreed() {
        return $('#email-sales_cta__agree').prop('checked')
    }

    function isValidForm() {
        if (
            isValidFirstName() &&
            isValidLastName() &&
            isValidCompanyName() &&
            isValidEmail() &&
            isNonFreeEmail() &&
            isValidPhone() &&
            isTermsAgreed()
        ) {
            return true
        }
        return false
    }

})
